import { _keys, exists, filterInstances, MissingDataException } from '@nu-art/ts-common';
import { valueID_Yes } from '@app/hcs-shared';
import { ModuleFE_Advisor_Value, ModuleFE_Advisor_Variable } from './modules/index.js';
export const formatFindings = (processedRawFindings) => {
    return processedRawFindings.reduce((currentState, currentFinding) => {
        if (currentFinding.findingId) {
            currentState.findingsToUpdate.push(currentFinding);
            return currentState;
        }
        currentState.processedRawFindings.push(currentFinding);
        return currentState;
    }, { findingsToUpdate: [], processedRawFindings: [] });
};
export const translateWizardData = (wizardData, wizardId, runtimeVariableId) => {
    const patientDataSnippets = [];
    const processedRawFindings = [];
    const findingsToUpdate = [];
    const snippetIds = _keys(wizardData);
    snippetIds.forEach(snippetId => {
        const snippetData = wizardData[snippetId];
        if ('text' in snippetData) { //Snippet submitted free text
            const textualData = snippetData;
            patientDataSnippets.push({
                snippetId: snippetId,
                text: textualData.text,
                parentSnippetId: wizardId,
                variableId: textualData.resolvingVariableId,
            });
        }
        else { //Snippet submitted form vars
            const varIds = _keys(snippetData);
            varIds.forEach(varId => {
                const variable = ModuleFE_Advisor_Variable.cache.unique(varId);
                if (!variable)
                    throw new MissingDataException(`Could not find variable for id ${varId}`);
                const value = ModuleFE_Advisor_Value.cache.unique(variable.valueId);
                if (!value)
                    throw new MissingDataException(`Could not find value for id ${variable.valueId} for variable with id ${variable._id}`);
                //Translate all variable data into EnumeratedProcessedRawFinding OR update findings if an existing finding id is set
                const data = snippetData[varId][0];
                if (!data) // data might be undefined, wizard pass all variables even if they have no data.
                    return;
                let attributes;
                const attributeIds = _keys(data.attributes ?? {}); // Added the null check, not all variables has attributes so it might throw an error when passing undefined to _keys
                if (attributeIds.length) {
                    attributes = filterInstances(attributeIds.map(attId => {
                        const valueIds = data.attributes[attId];
                        if (!valueIds.length)
                            return;
                        return { type: 'enumerated', variableId: attId, valueIds: valueIds };
                    }));
                }
                //No existing finding id, push new processed raw finding
                if (!data.existingFindingId) {
                    if (exists(data.rawValue)) { //Creating new numeric finding
                        const unitsId = value.data.unitsId;
                        processedRawFindings.push({
                            type: 'numeric',
                            variableId: variable._id,
                            isChiefComplaint: data.isChiefComplaint,
                            snippetId: data.snippetId,
                            value: data.rawValue,
                            measurementUnitId: unitsId,
                        });
                    }
                    else if (exists(data.valueId)) { //Creating new enum finding
                        processedRawFindings.push({
                            type: 'enumerated',
                            variableId: variable._id,
                            valueIds: filterInstances([data.valueId]),
                            isChiefComplaint: data.isChiefComplaint,
                            snippetId: data.snippetId,
                            attributes,
                        });
                    }
                }
                else { //Existing finding id exists, add to findingsToUpdate
                    if (exists(data.rawValue)) {
                        const unitsId = value.data.unitsId;
                        findingsToUpdate.push({
                            type: 'numeric',
                            variableId: variable._id,
                            value: data.rawValue,
                            isChiefComplaint: data.isChiefComplaint,
                            snippetId: data.snippetId,
                            measurementUnitId: unitsId,
                            findingId: data.existingFindingId,
                        });
                    }
                    else if (exists(data.valueId)) {
                        findingsToUpdate.push({
                            type: 'enumerated',
                            variableId: variable._id,
                            valueIds: filterInstances([data.valueId]),
                            attributes: (attributes?.length ? attributes : undefined),
                            findingId: data.existingFindingId,
                            snippetId: data.snippetId,
                            isChiefComplaint: data.isChiefComplaint,
                        });
                    }
                }
            });
        }
    });
    //Add processed raw finding for RTOrder for navigator to satisfy pre-conditions
    if (runtimeVariableId) {
        processedRawFindings.push({
            variableId: runtimeVariableId,
            valueIds: [valueID_Yes],
            type: 'enumerated',
            isChiefComplaint: false,
        });
    }
    return { patientDataSnippets, processedRawFindings, findingsToUpdate };
};
//# sourceMappingURL=translation-utils.js.map